import styled from 'styled-components';

export const RelatedProduct = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.gray8};
  padding-top: 2rem;
  padding: 1.5rem;
`;

export const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
`;

export const ShowMore = styled.div`
  margin-top: 2rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  & * > span {
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.blue6};
    text-decoration: underline;
    font-weight: 600;
  }
`;
